import Dialog from './src/dialog.js';

export default Dialog;



// WEBPACK FOOTER //
// ./packages/dialog/index.js